<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <form class="form-horizontal form-space" onsubmit="return false">
      <div v-show="isExist('JENJANG')" :class="{'form-group': true, 'has-error': errors.has('id_jenjang')}">
        <label class="col-md-3"><span class="required-label">*</span>Jenjang</label>
        <div class="col-md-4">
          <select
            type="text"
            name="id_jenjang"
            class="form-control"
            v-model="model.id_jenjang"
            v-validate="isExist('JENJANG') ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Jenjang</option>
            <option v-for="jenjang in options.jenjang" :key="jenjang.id_status" :value="jenjang.id_jenjang">
              {{ jenjang.nama_jenjang }}
            </option>
          </select>
          <span v-show="errors.has('id_jenjang')" class="error-label">Pilih Jenjang</span>
        </div>
      </div>
      <div v-show="isExist('NM_SEKOLAH')" :class="{'form-group': true, 'has-error': errors.has('nama_sekolah')}">
        <label class="col-md-3"><span class="required-label">*</span>Nama Sekolah</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nama_sekolah"
            placeholder="Nama Sekolah"
            class="form-control"
            maxlength="200"
            v-model="model.nama_sekolah"
            v-validate="isExist('NM_SEKOLAH') ? 'required' : ''"
          >
          <span v-show="errors.has('nama_sekolah')" class="error-label">Isi Nama Sekolah</span>
        </div>
      </div>
      <div v-show="isExist('NPSN')" :class="{'form-group': true, 'has-error': errors.has('npsn')}">
        <label class="col-md-3"><span class="required-label">*</span>Nomor Pokok Sekolah Nasional</label>
        <div class="col-md-6">
          <input
            type="text"
            name="npsn"
            placeholder="Nomor Pokok Sekolah Nasional"
            class="form-control"
            maxlength="50"
            v-model="model.npsn"
            v-validate="isExist('NPSN') ? 'required' : ''"
          >
          <span v-show="errors.has('npsn')" class="error-label">Isi Nomor Pokok Sekolah Nasional</span>
        </div>
      </div>
      <div v-show="isExist('NISN')" :class="{'form-group': true, 'has-error': errors.has('nisn')}">
        <label class="col-md-3"><span class="required-label">*</span>NISN</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nisn"
            placeholder="Nomor Induk Siswa Nasional (NISN)"
            class="form-control"
            maxlength="50"
            v-model="model.nisn"
            v-validate="isExist('NISN') ? 'required' : ''"
          >
          <span v-show="errors.has('nisn')" class="error-label">Isi NISN</span>
        </div>
      </div>
      <div v-show="isExist('JURUSAN')" :class="{'form-group': true, 'has-error': errors.has('id_jurusan_sekolah')}">
        <label class="col-md-3"><span class="required-label">*</span>Jurusan</label>
        <div class="col-md-4">
          <select
            type="text"
            name="id_jurusan_sekolah"
            class="form-control"
            v-model="model.id_jurusan_sekolah"
            v-validate="isExist('JURUSAN') ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Jurusan</option>
            <option v-for="jurusan in options.jurusan" :key="jurusan.id_jurusan" :value="jurusan.id_jurusan_sekolah">
              {{ jurusan.nama_jurusan_sekolah }}
            </option>
          </select>
          <span v-show="errors.has('id_jurusan_sekolah')" class="error-label">Pilih Jurusan</span>
        </div>
      </div>
      <div v-show="isExist('NO_IJAZAH')" :class="{'form-group': true, 'has-error': errors.has('nomor_ijazah')}">
        <label class="col-md-3"><span class="required-label">*</span>Nomor Ijazah / Nomor Surat Keterangan Lulus</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nomor_ijazah"
            placeholder="Nomor Ijazah / Nomor Surat Keterangan Lulus"
            class="form-control"
            maxlength="100"
            v-model="model.nomor_ijazah"
            v-validate="isExist('NO_IJAZAH') ? 'required' : ''"
          >
          <span v-show="errors.has('nomor_ijazah')" class="error-label">Isi Nomor Ijazah / Nomor Surat Keterangan Lulus</span>
        </div>
      </div>
      <div v-show="isExist('THN_MASUK')" :class="{'form-group': true, 'has-error': errors.has('tahun_masuk')}">
        <label class="col-md-3"><span class="required-label">*</span>Tahun Masuk</label>
        <div class="col-md-6">
          <input
            type="number"
            name="tahun_masuk"
            placeholder="Tahun Masuk"
            class="form-control"
            min="0" step="1" oninput="validity.valid||(value='');"
            maxlength="8"
            v-model="model.tahun_masuk"
            v-validate="isExist('THN_MASUK') ? 'required' : ''"
          >
          <span v-show="errors.has('tahun_masuk')" class="error-label">Isi Tahun Masuk</span>
        </div>
      </div>
      <div v-show="isExist('THN_LULUS')" :class="{'form-group': true, 'has-error': errors.has('tahun_lulus')}">
        <label class="col-md-3"><span class="required-label">*</span>Tahun Lulus</label>
        <div class="col-md-6">
          <input
            type="number"
            name="tahun_lulus"
            placeholder="Tahun Lulus"
            class="form-control"
            min="0" step="1" oninput="validity.valid||(value='');"
            v-model="model.tahun_lulus"
            v-validate="isExist('THN_LULUS') ? 'required' : ''"
          >
          <span v-show="errors.has('tahun_lulus')" class="error-label">Isi Tahun Lulus</span>
        </div>
      </div>
      <div v-show="isExist('NILAI_UAN')" :class="{'form-group': true, 'has-error': errors.has('nilai_uan')}">
        <label class="col-md-3"><span class="required-label">*</span>Jumlah Nilai UN</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nilai_uan"
            placeholder="Jumlah Nilai UN"
            class="form-control"
            maxlength="5"
            v-model="model.nilai_uan"
            v-validate="isExist('NILAI_UAN') ? 'required' : ''"
          >
          <span v-show="errors.has('nilai_uan')" class="error-label">Jumlah Nilai UN</span>
        </div>
      </div>
      <div v-show="isExist('NILAI_STTB')" :class="{'form-group': true, 'has-error': errors.has('nilai_sttb')}">
        <label class="col-md-3"><span class="required-label">*</span>Rata-Rata Nilai Ujian Sekolah</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nilai_sttb"
            placeholder="Rata-Rata Nilai Ujian Sekolah"
            class="form-control"
            maxlength="5"
            v-model="model.nilai_sttb"
            v-validate="isExist('NILAI_STTB') ? 'required' : ''"
          >
          <span v-show="errors.has('nilai_sttb')" class="error-label">Rata-Rata Nilai Ujian Sekolah</span>
        </div>
      </div>
      <div v-show="isExist('KETERANGAN')" class="form-group">
        <label class="col-md-3">Keterangan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="keterangan"
            placeholder="Keterangan"
            class="form-control"
            maxlength="100"
            v-model="model.keterangan"
          >
        </div>
      </div>
      <div v-show="isExist('SCAN_IJAZAH')" class="form-group">
        <label class="col-md-3"><span class="required-label">*</span>Ijazah / Surat Keterangan Lulus</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            :action="docEndPointIjazah"
            :headers="header"
            name="ijazah"
            :data="dataUpload"
            :on-error="handleError"
            :on-success="handleIjazahSuccess"
            :before-upload="beforeDocsUpload"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileModel.ijazah"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf/jpg/png dan tidak boleh lebih dari 1 MB</strong></div>
          </el-upload>
          <div v-if="ijazahUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="ijazahUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
    </form>
    <center>
      <pulse-loader style="margin: 15px" :loading="sending" color="#696969" size="10px"></pulse-loader>
    </center>
  </div>
</template>

<script>
import api from '@/api'
import Options from '@/helper/options'
import { baseURL } from '@/api/data'

export default {
  data () {
    return {
      init: false,
      loading: false,
      sending: false,
      ijazahUrl: '',
      model: {
        id_jurusan_sekolah: null,
        tahun_lulus: null,
        id_jenjang: null,
        npsn: null,
        nisn: null,
        nomor_ijazah: null,
        tahun_masuk: null,
        nilai_uan: null,
        nilai_sttb: null,
        keterangan: null,
        nama_sekolah: null
      },
      savedModel: null,
      fileModel: {
        ijazah: []
      },
      options: {
        jenjang: [],
        jurusan: []
      }
    }
  },
  computed: {
    header () {
      let token = localStorage.getItem('client-admisi-token')
      let headerAPI = {
        'Authorization': `Bearer ${token}`
      }
      return headerAPI
    },
    dataUpload () {
      let data = {nomor_pendaftar: this.nomorPendaftar}
      return data
    },
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    docEndPointIjazah () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/pendidikan_terakhir/ijazah'
      } else {
        return 'test'
      }
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(16).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.validateForm()
          .then(valid => {
            this.sendData()
              .then(success => {
                resolve(true)
              })
              .catch(e => {
                e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan', 'error')
                scroll(0, 0)
                resolve(true)
              })
          })
          .catch(e => {
            this.flash(e.message, 'error')
            scroll(0, 0)
            resolve(false)
          })
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(valid => {
            if (valid) {
              let ijazahUploaded = this.fileModel.ijazah.length > 0
              !ijazahUploaded && this.isExist('SCAN_IJAZAH') ? reject({message: 'belum ada file ijazah'}) : false
              resolve(true)
            } else {
              reject({message: 'isian belum lengkap'})
            }
          })
      })
    },
    isExist (name) {
      return this.$store.getters.formIsExist(name, 16)
    },
    handleError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.fileModel.ijazah = [{name: 'ijazah_' + this.nomorPendaftar + '.pdf'}]
        this.ijazahUrl = 'Test'
      }
    },
    handleExceed () {
      alert('maksimal 1 file')
    },
    handleIjazahSuccess (res, file) {
      this.getIjazah()
      alert('upload sukses')
    },
    beforeDocsUpload (file) {
      const isMIME = file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpeg'
      const isLt2M = file.size < 1000000
      !isMIME ? alert('Dokumen berformat pdf/jpg/png') : false
      !isLt2M ? alert('Dokumen tidak boleh lebih dari 1 MB') : false
      return isMIME && isLt2M
    },
    async initData () {
      if (!this.init) {
        this.options.jenjang = await Options.getOptionsJenjangSma()
        this.options.jurusan = await Options.getOptionsJurusanSekolah()
        this.getData()
        this.getIjazah()
        this.init = true
      }
    },
    updated () {
      this.$nextTick(function () {
        var elements = document.getElementsByClassName('el-upload__input')
        while (elements.length > 0) {
          elements[0].parentNode.removeChild(elements[0])
        }
      })
    },
    getData () {
      this.loading = true
      api.get('/v1/pendidikan_terakhir/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.model = responseData.data
            this.loading = false
          }
        })
        .catch(e => {
          this.loading = false
        })
    },
    sendData () {
      return new Promise((resolve, reject) => {
        this.sending = true
        if (process.env.NODE_ENV !== 'test') {
          const model = JSON.stringify(this.model)
          if (model !== this.savedModel) {
            api.post('/v2/pendidikan_terakhir/', {
              nomor_pendaftar: this.nomorPendaftar,
              ...this.model
            })
              .then(response => {
                this.sending = false
                this.savedModel = model
                resolve(response.data)
              })
              .catch(e => {
                this.sending = false
                reject(e.response)
              })
          } else {
            this.sending = false
            resolve(true)
          }
        } else {
          this.sending = false
          resolve(true)
        }
      })
    },
    getIjazah () {
      api.get('/v2/pendidikan_terakhir/ijazah/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.fileModel.ijazah = [{name: 'ijazah_' + this.nomorPendaftar + '.pdf'}]
            this.ijazahUrl = responseData.url
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/DataRiwayatPendidikanSebelumnya.vue